module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', [_c('div', {
    staticClass: "csos-logo"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo5.png")
    }
  })]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-vertical-demo default-active",
    attrs: {
      "default-active": _vm.activeIndex,
      "default-openeds": _vm.openedsIndex
    }
  }, [_c('el-submenu', {
    staticClass: "default-active",
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    slot: "title"
  }, [_c('translate', [_vm._v("Operation")])], 1)]), _vm._v(" "), _c('el-menu-item-group', [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1, 2, 3, 4].includes(_vm.currentAccount.is_admin)),
      expression: "[1, 2, 3, 4].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": "/operation/dashboard"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-1",
      "data-router": "{\"/operation/dashboard\": \"1-1\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("apps")]), _vm._v(" "), _c('translate', [_vm._v("Dashboard")])], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([0, 1].includes(_vm.currentAccount.is_admin)),
      expression: "[0, 1].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": "/operation/workgroup"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-2",
      "data-router": "{\"/operation/workgroup\": \"1-2\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("tune")]), _vm._v(" "), _c('translate', [_vm._v("WorkGroup")])], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([0, 1, 2, 4].includes(_vm.currentAccount.is_admin)),
      expression: "[0, 1, 2, 4].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": "/operation/log"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-3",
      "data-router": "{\"/operation/log\": \"1-3\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("event_note")]), _vm._v(" "), _c('translate', [_vm._v("Log")])], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([0, 1].includes(_vm.currentAccount.is_admin)),
      expression: "[0, 1].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": {
        name: 'operation.review',
        query: {
          type: 'sql'
        }
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-4",
      "data-router": "{\"/operation/review\":\"1-4\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_balance")]), _vm._v(" "), _c('translate', [_vm._v("Application")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1, 3].includes(_vm.currentAccount.is_admin)),
      expression: "[1, 3].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('translate', [_vm._v("Configuration")])], 1), _vm._v(" "), _c('el-menu-item-group', [_c('router-link', {
    attrs: {
      "to": "/settings/workgroup"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2-1",
      "data-router": "{\"/settings/workgroup\": \"2-1\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dvr")]), _vm._v(" "), _c('translate', [_vm._v("WorkGroup Manage")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/settings/cluster"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2-2",
      "data-router": "{\"/settings/cluster\": \"2-2\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_list")]), _vm._v(" "), _c('translate', [_vm._v("Cluster Manage")]), _vm._v(" "), (_vm.isUpdateAgent) ? _c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1].includes(_vm.currentAccount.is_admin)),
      expression: "[1].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": {
        name: 'team',
        query: {
          type: 'members'
        }
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2-3",
      "data-router": "{\"/settings/team\": \"2-3\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("group")]), _vm._v(" "), _c('translate', [_vm._v("Team Manage")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('translate', [_vm._v("System")])], 1), _vm._v(" "), _c('el-menu-item-group', [_c('router-link', {
    attrs: {
      "to": {
        name: 'statistics',
        query: {
          type: 'overview'
        }
      }
    }
  }, [_c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1, 2, 4].includes(_vm.currentAccount.is_admin)),
      expression: "[1, 2, 4].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "index": "3-1",
      "data-router": "{\"/system/statistics\": \"3-1\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("timeline")]), _vm._v(" "), _c('translate', [_vm._v("Statistic")])], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1, 2, 4].includes(_vm.currentAccount.is_admin)),
      expression: "[1, 2, 4].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": {
        name: 'log',
        query: {
          type: 'loginLogs'
        }
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3-2",
      "data-router": "{\"/system/log\": \"3-2\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chrome_reader_mode")]), _vm._v(" "), _c('translate', [_vm._v("System Log")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'alarmNotify'
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3-3",
      "data-router": "{\"/system/alarmNotify\": \"3-3\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("announcement")]), _vm._v(" "), _c('translate', [_vm._v("Alarm Notify")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('translate', [_vm._v("Personal")])], 1), _vm._v(" "), _c('el-menu-item-group', [_c('router-link', {
    attrs: {
      "to": "/personal/info"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "4-1",
      "data-router": "{\"/personal/info\": \"4-1\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('translate', [_vm._v("Account Info")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/personal/security"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "4-2",
      "data-router": "{\"/personal/security\": \"4-2\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("security")]), _vm._v(" "), _c('translate', [_vm._v("Account Security")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/personal/sshkey"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "4-3",
      "data-router": "{\"/personal/sshkey\": \"4-3\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _vm._v(" "), _c('span', [_vm._v("SSH KEY")])])], 1)], 1)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aa75477"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/left-nav.vue
// module id = 584
// module chunks = 4 5 6